/**
 * 対象書籍より前までの書籍のキーワード件数の合計（対象書籍の開始番号）と全合計を取得する
 */
export const getMatchedCountBeforeAndMmatchedTotal = (targetBookId, group1) => {
  let isFound = false
  let matchedCountBefore = 0
  let matchedTotal = 0
  for (let i = 0; i < group1.booksAreaProducts.length; i++) {
    if (typeof group1.booksAreaProducts[i].books !== 'undefined' && Array.isArray(group1.booksAreaProducts[i].books)) {
      for (let k = 0; k < group1.booksAreaProducts[i].books.length; k++) {
        const _bookId = group1.booksAreaProducts[i].books[k].book_id
        const _searchCount = group1.booksAreaProducts[i].books[k].search_count ?? 0
        if (_bookId === targetBookId) {
          isFound = true
        }
        if (!isFound) {
          matchedCountBefore += _searchCount
        }
        matchedTotal += _searchCount
      }
    }
  }
  for (let i = 0; i < group1.booksAreaBooks.length; i++) {
    const _bookId = group1.booksAreaBooks[i].book_id
    const _searchCount = group1.booksAreaBooks[i].search_count ?? 0
    if (_bookId === targetBookId) {
      isFound = true
    }
    if (!isFound) {
      matchedCountBefore += _searchCount
    }
    matchedTotal += _searchCount
  }

  return { matchedCountBefore: matchedCountBefore, matchedTotal: matchedTotal }
}

/**
 * 書籍エリアのハイライトしている書籍を設定
 */
export const setHighlightedItemInBooksArea = (targetBookType, targetNodeId, group1) => {

  const booksAreaProductsWork = group1.booksAreaProducts
  for (let i = 0; i < booksAreaProductsWork.length; i++) {
    for (let k = 0; k < booksAreaProductsWork[i].books.length; k++) {
      const nodeId = booksAreaProductsWork[i].books[k].id
      if (targetBookType === 'package_book' && nodeId === targetNodeId) {
        booksAreaProductsWork[i].books[k].isSelected = true
      } else {
        booksAreaProductsWork[i].books[k].isSelected = false
      }
    }
  }
  group1.booksAreaProducts = booksAreaProductsWork

  const booksAreaBooksWork = group1.booksAreaBooks 
  for (let i = 0; i < booksAreaBooksWork.length; i++) {
    const nodeId = booksAreaBooksWork[i].id
    if (targetBookType === 'single_book' && nodeId === targetNodeId) {
      booksAreaBooksWork[i].isSelected = true
    } else {
      booksAreaBooksWork[i].isSelected = false
    }
  }
  group1.booksAreaBooks = booksAreaBooksWork
}

/**
 * 前または次の書籍のIDと名称を取得する
 * @param {boolean} isNext 前の場合はfalse、次の場合はtrue
 * @return 見つからなかった場合はbookId=0
 */
export const getPrevOrNextBookInfo = (targetBookType, targetNodeId, isNext, group1) => {

  let list = []
  for (let i = 0; i < group1.booksAreaProducts.length; i++) {
    for (let k = 0; k < group1.booksAreaProducts[i].books.length; k++) {
      const bookType = 'package_book'
      const nodeId = group1.booksAreaProducts[i].books[k].id
      const bookId = group1.booksAreaProducts[i].books[k].book_id
      const name = group1.booksAreaProducts[i].books[k].name ?? ''
      list.push({ bookType: bookType, nodeId: nodeId, bookId: bookId, name: name })
    }
  }
  for (let i = 0; i < group1.booksAreaBooks.length; i++) {
    const bookType = 'single_book'
    const nodeId = group1.booksAreaBooks[i].id
    const bookId = group1.booksAreaBooks[i].book_id
    const name = group1.booksAreaBooks[i].name ?? ''
    list.push({ bookType: bookType, nodeId: nodeId, bookId: bookId, name: name })
  }

  if (!isNext) {
    list = list.reverse()
  }

  let resultBookType = ''
  let resultNodeId = 0
  let resultBookId = 0
  let resultBookName = ''

  for (let i = 0; i < list.length; i++) {
    const bookType = list[i].bookType
    const nodeId = list[i].nodeId
    if (bookType === targetBookType && nodeId === targetNodeId) {
      if (typeof list[i + 1].nodeId !== 'undefined') {
        resultBookType = list[i + 1].bookType
        resultNodeId = list[i + 1].nodeId
        resultBookId = list[i + 1].bookId
        resultBookName = list[i + 1].name
        break
      }
    }
  }

  return { bookType: resultBookType, nodeId: resultNodeId, bookId: resultBookId, bookName: resultBookName }
}
